import React from "react"
import "bootstrap/dist/css/bootstrap.css"
import UpgradeComponent from "../components/upgrade-components"

const UpgradePage = () => <UpgradeComponent></UpgradeComponent>

export default UpgradePage
